import React, { useContext, useState } from "react";
import mainbg from "../../assets/images/new/main-bg.png";
import mockup from "../../assets/images/new/AppImg.png"
import qr from "../../assets/images/new/qr.png";
import { QRCodeSVG } from 'qrcode.react';

import "./DownloadApp.css";
import ComingSoonModal from "../ComingSoonModal";
import { t } from "i18next";
import { LoaderContext } from "../../AuthContext/AuthContext";
const DownloadApp = ({ languageID }) => {
  const [showComingSoonModal, setShowComingSoonModal] = useState(false)
  return (
    <>
      {/* <div className="section-title text-center">
        <h6
          className="sec-title__tagline bw-split-in-right"
          style={{ perspective: "400px" }}
        >
          <img className=" tagline-img" src={batuk} alt="" /> Download App
        </h6>
      </div> */}
      <section className="video-one" style={{ padding: "0px" }}>
        <div
          className="video-one__bg jarallax"
          data-jarallax
          data-speed="0.3"
          data-imgposition="50% -100%"
          style={{
            backgroundImage: `url(${mainbg})`,
          }}
        ></div>

        <div
          className="video-one__shape-one"
          style={{
            backgroundImage: `url(${mainbg})`,
          }}
        ></div>

        <div
          className="video-one__shape-one"
          style={{
            backgroundImage: `url(${mainbg})`,
          }}
        ></div>

        <div className="container">
          <div className="row align-items-center">
            {/* Left Column: Content */}
            <div className="col-lg-8">
              {/* {languageID === 3 ? <h2 className="video-one__title" style={{ margin: "15px 0" }}>
                भक्तीसाठी एक टॅप- आताच माय ओम नमो अ‍ॅप डाउनलोड करा!
              </h2> :
                languageID === 2 ? <h2 className="video-one__title" style={{ margin: "15px 0" }}>
                  एक टैप में भक्ति — अभी Myomnamo ऐप डाउनलोड करें
                </h2> : */}
              <h2 className="video-one__title" style={{ margin: "15px 0" }}>
                {t("One Tap to Devotion — Download Myomnamo App Now.")} !
              </h2>

              {/* QR Code Image */}
              <div className="qr-code-wrapper" style={{ margin: "20px 0" }}>
                {/* <img
                  src={qr}
                  alt="QR Code"
                  style={{ maxWidth: "150px", height: "auto" }}

                />  */}
                <QRCodeSVG
                  value="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo&hl=en&pli=1"
                  style={{
                    maxWidth: "150px",
                    height: "auto",
                    border: "5px solid white",
                    borderRadius: "10px", // optional: makes corners rounded
                    backgroundColor: "white" // ensures no transparency
                  }}
                />
                {/* <QRCodeSVG  style={{ maxWidth: "150px", height: "auto" }} value={'https://play.google.com/store/apps/details?id=spiritualapp.myomnamo&hl=en&pli=1'}   /> */}
              </div>

              <div className="app-buttons text-center">
                <a
                  className="google-play-btn"
                  href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-google-play"></i>
                  <span>
                    <small>Get it on</small>
                    <br />
                    Google Play
                  </span>
                </a>
                <a
                  className="app-store-btn"
                  style={{ cursor: 'pointer' }}
                  href="https://apps.apple.com/in/app/myomnamo/id6747122767"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-apple"></i>
                  <span>
                    <small>Download on the</small>
                    <br />
                    App Store
                  </span>
                </a>

              </div>
            </div>

            {/* Right Column: Video */}
            <div
              className="col-lg-4 text-center"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={mockup} alt="Play Video" height={500} />
            </div>
          </div>
        </div>
      </section>
      <ComingSoonModal show={showComingSoonModal} onClose={() => setShowComingSoonModal(false)} />
    </>
  );
};

export default DownloadApp;
